import { Icon } from "@atoms";
import { faIcon } from "@utils/faIcon";
import clsx from 'clsx';

function Spinner(props) {
    const { centered = false } = props

    return <span className={clsx("spinner", "fa-2x", {"spinner-centered": centered})} aria-label="Loading..."><Icon containerClassName="icon-inline" icon={faIcon({ name: "spinner-third", style: "regular" })} spin className="spin-fast" /></span>
}

export default Spinner
